import { useContext } from 'react'

import Header from 'Root/App/Header'
import Download from 'Root/App/Header/Buttons/Download'
import MenuContainer from 'Root/App/Menu/Container'
import CallToAction from 'Root/Pages/Collection/Component/CallToAction'
import { Context as CollectionContext } from 'Root/Pages/Collection/Component/Context'
import { useCurrentUserId } from 'lib/use-current-user-id'
import { useIsClient } from 'lib/use-is-client'

import styles from './index.module.css'

interface CollectionContentHeaderProps {
  content: any
}

const CollectionContentHeader = ({ content }: CollectionContentHeaderProps) => {
  const isClient = useIsClient()
  const userId = useCurrentUserId()
  const { collection } = useContext(CollectionContext)

  if (!isClient) return null

  const creator = {
    profileName: content.creator.workspace?.user?.vanity_name,
    logoURL: content.creator.workspace?.brandLogoSmall,
  }

  return (
    <Header creator={creator}>
      {collection && <CallToAction userID={userId} collection={collection} />}

      {!content.canManage &&
        !!userId &&
        content.__typename === 'PdfContent' &&
        content.canDownload && <Download element={content} />}

      {!!userId && (
        <MenuContainer
          buttonSize="S"
          className={styles.menuContainerButton}
          key={`menu_${content.id}`}
        />
      )}
    </Header>
  )
}

export default CollectionContentHeader
